/**
 * @description 國家的旅遊警告級別 (enum)
 */
export enum CountriesWarningLevelEnum {
  /** 無 */
  None = 'none',
  /** 拒絕 */
  Refuse = 'refuse'
}
